<template>
    <div class="rehear">
        <el-radio-group v-model="value" size="small" class="m-b">
            <span v-for="item in screen" :key="item.value">
                <el-radio-button :label="item.value">{{item.text}}</el-radio-button>
            </span>
        </el-radio-group>
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="ranking" label="排名" width="180"></el-table-column>
            <el-table-column prop="name" label="姓名" width="180"></el-table-column>
            <el-table-column prop="grade" label="班级"></el-table-column>
            <el-table-column prop="yes" label="答对量"></el-table-column>
            <el-table-column prop="num" label="作答量"></el-table-column>
            <el-table-column prop="correct" label="正确率"></el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    data() {
        return {
            screen: [
                { value: "1", text: "月底" },
                { value: "2", text: "年度" }
            ],
            value: "1",
            tableData: [
                {
                    ranking: "1",
                    name: "张三",
                    grade: "xx",
                    yes: "15",
                    num: "100",
                    correct: "15%"
                }
            ]
        };
    }
};
</script>
<style lang="less">
.rehear {
    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        background-color: #d1f0ea;
        color: #30b79b;
        border-color: #d1f0ea;
    }
}
</style>